import { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { isEqual } from "lodash";
import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { fetchPicklistOptions } from "store/actions/picklists";
import { picklistsSelectors } from "store/selectors";


export const useResearchTeamRoles = () => {
	const prevRoles = useRef();
	const { options: roles } = useSelector(picklistsSelectors.researchTeamRoles);

	useEffect(() => {
		if (!isNonEmptyArray(roles) && !isEqual(prevRoles.current, roles)) {
			fetchPicklistOptions("researchTeamRoles");
		}

		prevRoles.current = roles;
	}, [ roles ]);

	const getResearchTeamRoleByName = useCallback(name => {
		const lcName = isNonEmptyString(name) ? name.toLowerCase() : name;

		return isNonEmptyArray(roles)
			? roles.find(role => role.name.toLowerCase() === lcName)
			: undefined;
	}, [ roles ]);


	return { roles, getResearchTeamRoleByName };
};

export default useResearchTeamRoles;
